import React from 'react';
import {office} from "../../../models/office";

type OfficeListBoxProps = {
  office: office,
}

export const OfficeListBox = ({office}: OfficeListBoxProps) => {
  return (
    <div className="col">
      <div className={`__admin_office_card card shadow-sm ${office.enabled ? 'border-success' : ''}`}>
        <div className="card-body">
          <h5 className="card-title">{office.label}</h5>
          <p className="card-text">
            <strong>Actif :</strong> {office.enabled ? (<span className="badge bg-success">Oui</span>) : (<span className="badge bg-warning">Non</span>)}
          </p>
        </div>
      </div>
    </div>
  )
}
